var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from "hanako-ts/dist-legacy/Component";
export class FileInput extends Component {
    constructor() {
        super('FileInput', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            FileInput.originalLabelText = $('.field-file').find('.label').text();
            $('.field-file input').on('change', FileInput.update);
            this.success();
        });
    }
}
FileInput.update = (event, field) => {
    const HTMLField = field.get(0);
    let labelText;
    if (HTMLField.files[0].size > 2097152) {
        alert('Max file size is 2Mo');
        field.val('');
        labelText = FileInput.originalLabelText;
    }
    else {
        labelText = HTMLField.files[0].name;
    }
    field.parents('.field-file').find('.label').text(labelText);
};
